import { parseISO } from 'date-fns';

const mapStatus = (status) => {
  switch (status) {
    case 'returnToBuyer':
      return 'Regreso de pase';

    case 'assignedToPatient':
      return 'Asignado a paciente';

    case 'analysisScheduled':
      return 'Análisis agendado';

    case 'analysisCheckedIn':
      return 'Análisis realizado';
    default:
      return '--';
  }
}

export const mapInbodyPassHistory = inbodyHistory => {
  const { action, assignmentDate, patient, buyer } = inbodyHistory;
  
  return {
    _id: inbodyHistory._id,
    status: {
      value: action,
      formattedValue: mapStatus(action),
    },
    date: parseISO(assignmentDate),
    patient: {
      name: patient.name + ' ' + patient.lastName,
      phoneNumber: patient.phoneNumber,
    },
    nutritionist: {
      phoneNumber: buyer.phoneNumber,
      email: buyer.email,
    },
  };
}